import axios from 'axios';
import { toast } from 'react-toastify';
import { MAIN_URL } from './url';

export const requestGet = async (url, options = {}) => {
  try {
    const response = await axios.get(MAIN_URL + url, { params: options });
    return response.data;
  } catch (error) {
    return console.log(error);
  }
};

export const requestPost = async (url, data = {}, config = {}) => {
  try {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
    axios.defaults.headers.post['Access-Control-Allow-Credentials'] = 'true';
    axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Host, Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-XSRF-TOKEN, Origin, Access-Control-Request-Origin, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin, access-control-allow-origin, Access-Control-Allow-Credentials, access-control-allow-credentials, Access-Control-Allow-Headers, access-control-allow-headers, Access-Control-Allow-Methods, access-control-allow-methods';



    const response = await axios.post(MAIN_URL + url, data, config);
    return response.data;
  } catch (error) {
    return toast.error(error.message);
  }
};

export const requestDelete = async (url, data = {}, config = {}) => {
  try {
    const response = await axios.delete(MAIN_URL + url, data, config);
    return response.data;
  } catch (error) {
    return console.log(error);
  }
};
